import React, { useState } from 'react'
import { Button } from 'react-bootstrap'
import TextField from '../../ui/TextField'
import TextAreaField from '../../ui/TextAreaField'
import RadioField from '../../ui/RadioField'
import SubmitField from '../../ui/SubmitField'
import { format } from 'date-fns'

const longDateFormat = "EEEE, MMMM do, yyyy"

const DetailsForm = ({ meetingDetails, setMeetingDetails, meetingDetailErrors, availableLocations, selectedDate, selectedTime, userAppointmentCalendar, onBack, onSubmit }) => {
  const [showAdditionalGuests, setShowAdditionalGuests] = useState(false)
  const [loading, setLoading] = useState(false)

  const formattedDate = format(selectedDate, longDateFormat)

  async function handleSubmit(event) {
    event.preventDefault()
    setLoading(true)
    await onSubmit()
    setLoading(false)
  }

  return (
    <div className="appointment-selector-details-form">
      <p>
        You chose {formattedDate} at {selectedTime}.
      </p>
      <Button
        onClick={onBack}
        variant="link"
      >
        &laquo; See other available dates and times
      </Button>
      <form onSubmit={handleSubmit}>
        <div className="mb-3 mt-3">
          <RadioField
            name="location"
            label="Meeting Location"
            value={meetingDetails.location}
            onChange={value => setMeetingDetails({ ...meetingDetails, location: value })}
            options={availableLocations}
            required
            errors={meetingDetailErrors}
          />
          <div className="mb-1 mt-1">
            { (meetingDetails.location == "Phone" && userAppointmentCalendar.attributes.locationPhoneInboundOutbound == "inbound") &&
              <p className="text-muted">We'll call you at the phone number you provide below.</p>
            }

          </div>
        </div>
        <div className="mb-3 mt-3">
          <TextField
            name="guestName"
            label="Name"
            value={meetingDetails.guestName}
            required
            onChange={value => setMeetingDetails({ ...meetingDetails, guestName: value })}
            errors={meetingDetailErrors}
          />
        </div>
        <div className="mb-3">
          <TextField
            name="guestEmail"
            label="Email"
            value={meetingDetails.guestEmail}
            required
            onChange={value => setMeetingDetails({ ...meetingDetails, guestEmail: value })}
            errors={meetingDetailErrors}
          />
        </div>
        <div className="mb-3">
          <TextField
            name="guestPhone"
            label="Phone"
            value={meetingDetails.guestPhone}
            required={meetingDetails.location == "Phone" && userAppointmentCalendar.attributes.locationPhoneInboundOutbound == "inbound"}
            onChange={value => setMeetingDetails({ ...meetingDetails, guestPhone: value })}
            errors={meetingDetailErrors}
          />
        </div>
        <div className="mb-3">
          {!showAdditionalGuests && (
            <Button
              onClick={() => setShowAdditionalGuests(true)}
              variant="outline-primary"
              size="sm"
            >
              Add Guests
            </Button>
          )}
          { showAdditionalGuests &&
            <TextField
              name="additionalGuests"
              label="Guest Email(s)"
              value={meetingDetails.additionalGuests}
              onChange={value => setMeetingDetails({ ...meetingDetails, additionalGuests: value })}
              hint="Include up to 5 additional guests. Separate each email with a comma."
              errors={meetingDetailErrors}
            />
          }
        </div>
        <div className="mb-3">
          <TextAreaField
            name="message"
            label="Additional Notes"
            value={meetingDetails.message}
            onChange={value => setMeetingDetails({ ...meetingDetails, message: value })}
            errors={meetingDetailErrors}
          />
        </div>
        <div className="mb-3">
          <SubmitField value={loading ? "Submitting..." : "Submit"} block disabled={loading} />
        </div>
      </form>
    </div>
  )
}

export default DetailsForm
